module.exports = __webpack_public_path__ + "static/media/quieromibarrio.5f7d86fa.jpg";